export const removeFilter = (activeFilters) => {
  let asArray = Object.entries(activeFilters);
  let filtered = asArray.filter(([key, value]) => value !== 'All');
  let activeFiltersObject = Object.fromEntries(filtered);
  return activeFiltersObject;
};
